import SlimSelect from 'slim-select'

export default function customSelect() {

  const customSelects = Array.prototype.slice.call(document.querySelectorAll('.js-custom-select'));
  let settings;

  customSelects.forEach(elem => {
    const options = Array.prototype.slice.call(elem.querySelectorAll('option'));
    const isMultiple = !!$(elem).attr('multiple');
    const data = options.map((option) => {
      const text = option.innerText;
      const selected = $(option).is(':selected');
      const { value } = option;
      const { href, onclick, placeholder } = option.dataset;
      // let { placeholder } = elem.dataset;

      let html;
      if (elem.dataset.settings === 'custom') {
        html = href ? `<a href='${href}' onclick="${onclick}">${text}</a>` : `${text}`;
      } else {
        html = isMultiple ? `<a href='${href}' onclick="${onclick}"><p>${text}</p></a>` : `${text}`;
      }

      // placeholder = (placeholder && index === 0) ? placeholder : false;

      return {
        placeholder: placeholder ? option.innerText : false,
        innerHTML: html,
        text,
        value,
        selected,
      }
    });

    const value = $(elem).val();
    settings = {
      data,
      select: elem,
      showSearch: false,
      closeOnSelect: !isMultiple,
      valuesUseText: true,
      allowDeselect: isMultiple,
      allowDeselectOption: isMultiple,
    };

    // eslint-disable-next-line no-unused-vars
    const select = new SlimSelect(settings);

    if (isMultiple || (elem.dataset.settings === 'custom')) {
      select.setData(data);
      select.set(value);
    }

    select.beforeOnChange = (() => {
      if (isMultiple) {
        if (select.selected().includes('Все')) {
          select.data.data.forEach(el => {
            // eslint-disable-next-line no-param-reassign
            el.selected = false;
          });
        }
      }
    });

    if (isMultiple) {
      const customSelectWrapper = $(elem).siblings('.js-custom-select');
      const $valueWrapper = customSelectWrapper.find('.ss-multi-selected');
      const truncated = customSelectWrapper.find('.ss-truncate-text');
      if (truncated.length) truncated.remove();

      const text = select.selected().join(', ');
      $valueWrapper.append(`<p class="ss-truncate-text">${text}</p>`);
    }

    select.onChange = ((info) => {
      if (isMultiple ) {


        const customSelectWrapper = $(elem).siblings('.js-custom-select');
        const $valueWrapper = customSelectWrapper.find('.ss-multi-selected');
        let truncated = customSelectWrapper.find('.ss-truncate-text');
        if (truncated.length) truncated.remove();
        const values = info.map((option) => {
          return option.text;
        });

        const text = values.join(', ');
        $valueWrapper.append(`<p class="ss-truncate-text">${text}</p>`);

        if (select.selected().includes('Все')) {
          select.data.data.forEach(el => {
            if (el.value === 'Все') {
              truncated = customSelectWrapper.find('.ss-truncate-text');

              if (truncated.length) truncated.remove();
              $valueWrapper.append(`<p class="ss-truncate-text">Все</p>`);
            }
            // eslint-disable-next-line no-param-reassign
            el.selected = true;
          });
        }
      }
    });
  })
}
